import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Typography, Box, useTheme, useMediaQuery } from "@mui/material";

function BigData() {
    const [bigdata, setBigdata] = useState([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    useEffect(() => {
        axios
            .get("/files/solutions/bigData.txt")
            .then((res) => setBigdata(res.data))
            .catch((err) => console.error(err));
    }, []);

    const renderContent = (data) => {
        if (typeof data === "string") {
            return (
                <Typography
                    variant="body1"
                    sx={{ mb: 2, fontFamily: "Raleway, sans-serif" }}
                >
                    {data}
                </Typography>
            );
        } else if (Array.isArray(data)) {
            return data.map((item, index) => (
                <Box key={index} sx={{ mb: 2, pl: typeof item === "string" ? 2 : 0 }}>
                    {renderContent(item)}
                </Box>
            ));
        } else if (typeof data === "object" && data !== null) {
            return Object.entries(data).map(([key, value], idx) => (
                <Box key={idx} sx={{ mb: 2 }}>
                    <Typography
                        variant="h5"
                        sx={{ fontWeight: "bold", mb: 1, color: "#030366" }}
                    >
                        {key}
                    </Typography>
                    
                    {renderContent(value)}

                    {key.toLowerCase() === "key services" && (
                        <Box sx={{ textAlign: "center", mb: 2 }}>
                            <img
                                src="/images/bigdata.jpg"
                                alt="Key Services"
                                style={{
                                    maxWidth: "100%",
                                    height: "auto",
                                    borderRadius: "10px",
                                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                    marginBottom: "20px"
                                }}
                            />
                        </Box>
                    )}
                </Box>
            ));
        }
        return null;
    };

    const renderContent1 = () => {
        return (
            <Box>
                <Typography
                    variant="h5"
                    sx={{ fontWeight: "bold", mb: 1, color: "#030366" }}
                >
                    Business Value
                </Typography>
                <Typography
                    variant="body1"
                    sx={{ mb: 1, pl: 2, fontFamily: "Raleway, sans-serif" }}
                >
                    • Improve insights based on analytics
                </Typography>
                <Typography
                    variant="body1"
                    sx={{ mb: 1, pl: 2, fontFamily: "Raleway, sans-serif" }}
                >
                    • Provide insights to real-time analysis
                </Typography>
                <Typography
                    variant="body1"
                    sx={{ mb: 1, pl: 2, fontFamily: "Raleway, sans-serif" }}
                >
                    • Improve business outcomes and manage risk, now and in the future
                </Typography>
                <Typography
                    variant="body1"
                    sx={{ mb: 1, pl: 2, fontFamily: "Raleway, sans-serif" }}
                >
                    • All types of information can be tapped
                </Typography>
            </Box>
        );
    };

    return (
        <Box sx={{ minHeight: "100vh", py: 2 }}>
            <Container maxWidth="lg">
                <Typography
                    align="center"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "#030366",
                        mb: { xs: 4, sm: 5, md: 6 },
                        mt: 7,
                        fontSize: {
                            xs: "1.8rem", // mobile
                            sm: "2.2rem", // tablet
                            md: "2.8rem", // laptop
                            lg: "3rem",  // desktop
                        },
                    }}
                >
                    Big Data & Advanced Analytics
                </Typography>

                <Box sx={{ textAlign: "justify", lineHeight: 1.8 }}>
                    {bigdata.length > 0 ? renderContent(bigdata) : "Loading content..."}
                    {renderContent1()}
                </Box>
            </Container>
        </Box>
    );
}

export default BigData;
